import { NgModule } from '@angular/core';
import { AsyncButtonDirective } from './async-button.directive';
import { MatLegacyProgressSpinner as MatProgressSpinner } from '@angular/material/legacy-progress-spinner';

@NgModule({
    imports: [],
    exports: [AsyncButtonDirective],
    declarations: [AsyncButtonDirective],
    providers: []
})
export class AsyncButtonDirectiveModule {}
